'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { FunctionComponent, useContext } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import * as z from 'zod'
import { Button } from '../Button/Button'
import { AlertNotificationContext } from '../../context/AlertNotificationContext'
import { useTranslation } from '../../context/ConfigContext'
import useUnsubscribeEmailToNewsletter from '../../../core/hook/useUnsubscribeEmailToNewsletter'
import { handleError } from '../../../core/hook/utils'

const UnsubscribeToNewsletter: FunctionComponent = () => {
  const t = useTranslation()

  const NewsletterFormType = z.object({
    email: z.string().email({
      message: t('Please enter a valid email address (Ex: johndoe@domain.com).', {}, false),
    }),
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ email: string }>({
    resolver: zodResolver(NewsletterFormType),
  })

  const { unsubscribeEmailToNewsletter } = useUnsubscribeEmailToNewsletter()

  const { addNotification } = useContext(AlertNotificationContext)

  const onSubmit: SubmitHandler<{ email: string }> = (data) => {
    unsubscribeEmailToNewsletter(data.email)
      .then(() => {
        addNotification(t('Newsletter unsubscription success', {}, false))
      })
      .catch((e) => {
        handleError(e, false)
        addNotification(t('newsletter-unsubscribe-message-nok', {}, false))
      })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} data-test='unsubscribe-to-newsletter-form'>
      <div className='form-control'>
        <label htmlFor='email'>{`${t('Email', {}, true)}*`}</label>
        <input type='email' {...register('email')} />
        {errors.email?.message && <p className='error-message'>{errors.email.message}</p>}
      </div>

      <Button
        classname='black'
        type='submit'
        size='large'
        label={t('Unsubscribe', {}, false)}
        style='dark'
      />
    </form>
  )
}

export default UnsubscribeToNewsletter
